export const select_operator = [
	{ name: '<', value: '<' },
	{ name: '>', value: '>' },
	{ name: '=', value: '=' }
];
